import React from 'react';
import FlashDealContainer from './FlashDealContainer';
 
interface FlashDealsProps {
  onTripClick?: (trip: any) => void;
  onTabChange?: (tabId: string) => void;
  onCloseTab?: (tabId: string) => void;
  mode?:  'create' | 'edit';
  flashDealData?: any;
}

const FlashDeals: React.FC<FlashDealsProps> = ({ mode = 'create', flashDealData, onCloseTab, onTripClick, onTabChange }) => {
  const handleSuccess = (data: any) => {
    
    // After successful creation, switch to edit mode by updating the tab
    if (data?.mode === 'create' && data?.result?.data?.dealCode && onTripClick && onTabChange) {
      const createdDealCode = data.result.data.dealCode;
      
      // Close the 'FlashDeals' create tab first
      if (onCloseTab) {
        onCloseTab('FlashDeals');
      }
      
      // Add the newly created flash deal as a new tab in edit mode
      const newFlashDeal = {
        tripId: createdDealCode,
        trip_id: createdDealCode,
        tripCode: createdDealCode,
        tripType: 'FLASH_DEALS',
        mode: 'edit',
        dealCode: createdDealCode,
        carType: '',
        carModel: '',
        operator: ''
      };
      onTripClick(newFlashDeal);
      
      // Switch to the new edit tab
      setTimeout(() => {
        onTabChange(createdDealCode);
      }, 100);
    }
  };

  const handleCancel = () => {
    
   if (onCloseTab) {
      onCloseTab(flashDealData?.dealCode || 'FlashDeals');
    }
    // You can add navigation or other logic here
  };

  return (
    <FlashDealContainer
      mode={mode}
      dealCode={flashDealData?.dealCode}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      onCloseTab={onCloseTab}
    />
  );
};

export default FlashDeals;